export default "__VITE_ASSET__CU1G8i6s__"